<template>

    <b-modal id="bv-edit-comment" size="lg" hide-footer>
      <template #modal-title>Edit Comment</template>

      <div class="row">
        <div class="col">
            <textarea
                class="form-control shadow-none inputbox"
                rows="5"
                v-model="comment.content"></textarea>
        </div>
      </div>

      <div class="row pt-3 pb-2">
        <div class="col">
        <button v-if="updating" type="button" class="btn btn-secondary submit col">
        <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i>Please wait ...</button>
        <button v-else type="button" class="btn btn-success submit col" @click="sendComment">Save</button>
        </div>
      </div>

    </b-modal>

</template> 

<script>
export default {

  props: ['comment'],
  
  data() {
    return {
      updating: false,
    };
  },

  methods: {

    hideEditCommentModal() {
      this.$bvModal.hide('bv-edit-comment');
    },

            sendComment() {

        if (this.comment.content == null || this.comment.content == '') {this.sweetfire('Please write a comment')}

        else {

          this.updating = true;

          axios.post('/comment/update', {
            id: this.comment.id,
            content: this.comment.content, 
            action: 'update'})
        .then((response) => {

          if (response.data.success) {
            this.hideEditCommentModal();
            // this.showToaster(response.data.message);
            this.$emit('get-comments');
          } else {
            this.sweetfire(response.data.message);
          }
          
          this.updating = false;

        });

        }

      },

      showToaster(text) {
      this.$toaster.info(text, { timeout: 2500 });
      },

      sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: {
              title: "popup-title",
            },
    })

    },
  },
};
</script>